__turbopack_context__.v({
  "container": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__container",
  "disabled": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__disabled",
  "leftContainer": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__leftContainer",
  "priceText": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__priceText",
  "priceTextDisabled": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__priceTextDisabled",
  "priceTextWide": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__priceTextWide",
  "quantityModifier": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__quantityModifier",
  "variantContainer": "QuantityModifierAddonGroupForm-module-scss-module__C5h5qG__variantContainer",
});
